import { GenericResource, IHttpAgent } from '@sparelabs/http-client-utils'
import {
  ICaseTypePatchBody,
  ICaseTypePostBody,
  ICaseTypeResponse,
  IGetPublicCaseTypeQueryParams,
  IListCaseTypeQueryParams,
  IPublicCaseTypeResponse,
} from '../types'
import { Resources } from './ResourcesType'

export class CaseTypeResource extends GenericResource<
  ICaseTypeResponse,
  IListCaseTypeQueryParams,
  ICaseTypePatchBody,
  ICaseTypePostBody
> {
  public get = this.buildGet()
  public list = this.buildList()
  public post = this.buildPost()
  public patch = this.buildPatch()

  public async getPublic(params: IGetPublicCaseTypeQueryParams): Promise<IPublicCaseTypeResponse> {
    const res = await this.agent.get<IPublicCaseTypeResponse>('public/engage/caseType', { params })
    return res.data
  }

  constructor(agent: IHttpAgent) {
    super(Resources.CaseTypes, agent)
  }
}
